import BulletinBoard from './bulletin-board-container'
export default BulletinBoard
